import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/variables.css';
import './styles/components/button.css';
import './styles/components/card.css';
import './styles/components/modal.css';
import './styles/components/uploader.css';
import './styles/components/tabs.css';
import './styles/layout/header.css';
import './styles/layout/footer.css';
import './styles/layout/sidebar.css';
import './styles/pages/catalog.css';
import './styles/pages/product.css';
import './styles/pages/cart.css';
import './styles/pages/checkout.css';
import './styles/pages/profile.css';
import './styles/mobile.css';
import './index.css';
import './styles/marketplace.css';
import './styles/buyerWorkspace.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
